<main class="main-dashboard">
  <article class="main-canvas">
    <section class="canvas-container">
      <section class="dashboard-items">
        <div class="canvas-item">
          <div
            class="canvas-header row justify-content-between align-items-center"
          >
            <div class="title col-sm-6">
              <div class="d-flex align-items-center">
                <div class="edit">
                  <button title="back page" (click)="backToOnboarding()">
                    <span><i class="ri-arrow-left-line"></i></span>
                  </button>
                </div>
                <h3 class="px-3">Onboarding IT</h3>
              </div>
            </div>
          </div>
          <div class="canvas-header row justify-content-between align-items-center">
            <div class="title col-sm-6 d-flex">
              <h3><a (click)="openHrmonboarding()" class="cursor-pointer">HR</a></h3>
              <h3><a (click)="openndaonboarding()" class="cursor-pointer">NDA</a></h3>
              <h3><a (click)="openItonboarding()" class="active cursor-pointer">IT</a></h3>
            </div>
          </div>
          <div class="canvas-data">
            <form [formGroup]="userCreationForm">
              <div class="row">
                <div class="col-sm-12">
                  <h5>Personal Information</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="userId" />
                      <label class="floating-label-special">New User</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" value="{{this.userFullName}}" disabled/>
                      <label class="floating-label-special">Full Name</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="passwordBoolean" required>
                        <option value="" disabled selected>Select Password</option>
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                      <label class="floating-label-special">Password*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="emailId" required/>
                      <label class="floating-label-special">Email Id*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <h5>Company Information</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="localId" />
                      <label class="floating-label-special">Emp Id</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="domainUserId"/>
                      <label class="floating-label-special">Domain User ID</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <input type="text" formControlName="requestedDate" />
                      <label class="floating-label-special">User ID Creation Date</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="status">
                        <option value="" disabled selected>Select Status</option>
                        <option value="withHrTeam">With Hr Team</option>
                        <option value="withNDATeam">With NDA Team</option>
                        <option value="withItTeam">With IT Team</option>
                        <option value="waitingForApproval">Waiting For Approval</option>
                        <option value="approved">Approved</option>
                      </select>
                      <label class="floating-label-special">Status*</label>
                      <i class="ri-file-list-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="biometric">
                        <option value="" disabled selected>Select Bio Metrics</option>
                        <option value="Access Door 1">Access Door 1</option>
                        <option value="Access Door 2">Access door 2</option>
                      </select>
                      <label class="floating-label-special"> Bio Metrics</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="ismsTraining" required>
                        <option value="" disabled selected>Select ISMS Training</option>
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                      <label class="floating-label-special">ISMS Training*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <!-- <div class="input">
                  <a href="https://forms.office.com/r/fHxBemJi7g" target="_blank" rel="noopener noreferrer">ISMS 27001-2013 Standard Awareness Training Exam !</a>
                </div> -->
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="ismsAgreement" required>
                        <option value="" disabled selected>Select ISMS Agreement</option>
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                      <label class="floating-label-special">ISMS Agreement*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>

                <!-- Can remove commented code after Suraj's Confirmation -->
                <!-- <div class="d-flex gap-2 justify-content-end mt-3" *ngIf="this.usersCreationData.status === 'withItTeam'">
                  <button class="btn btn-outline-primary" (click)="updateUserCreation()" *ngIf="this.userCreationId" [disabled]="!userCreationForm.valid ? true : null">Save</button>
                  <button class="btn btn-primary" (click)="backToOnboarding()">Cancel</button>
                </div> -->
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <h5>Other Information</h5>
                </div> 
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="licenseAllocation">
                        <option value="" disabled selected>Select license Allocation</option>
                        <option value="Enterprise Mobility + Security E3">Enterprise Mobility + Security E3</option>
                        <option value="Microsoft 365 Business Basic">Microsoft 365 Business Basic</option>
                        <option value="Microsoft 365 Business Standard">Microsoft 365 Business Standard</option>
                      </select>
                      <label class="floating-label-special">License Allocation</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4" >
                  <div class="input">
                    <div class="input-item">
                      <select formControlName="licenseRequired" (change)="checkLicenseStatus($event.target.value)">
                        <option value="" disabled selected>Select License Requirement</option>
                        <option [ngValue]="true">Yes</option>
                        <option [ngValue]="false">No</option>
                      </select>
                      <label class="floating-label-special">License Requirement*</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-4" *ngIf="this.license">
                  <div class="input">
                    <div class="input-item">
                      <!-- <ng-select [items]="licenseTypeList" class="w-100" [multiple]="true" bindLabel="licenseTypeName" bindValue="licenseTypeName" placeholder="Select Licence" formControlName="licenseType">
                      </ng-select> -->
                      <select formControlName="licenseType">
                        <option value="" disabled selected>Select License Type</option>
                        <option value="Enterprise Mobility + Security E3">Enterprise Mobility + Security E3</option>
                        <option value="Microsoft 365 Business Basic">Microsoft 365 Business Basic</option>
                        <option value="Microsoft 365 Business Standard">Microsoft 365 Business Standard</option>
                      </select>
                      <label class="floating-label-special">License Type</label>
                      <i class="ri-user-line"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-3" *ngIf="this.license">
                  <button class="btn btn-primary" (click)="notifyLicense()">Submit For Licence</button>
                </div>
              </div>

              <!-- Need to comment code after Suraj's Confirmation -->
              <div class="d-flex gap-2 justify-content-end mt-3">
                <button class="btn btn-outline-primary" (click)="updateUserCreation()" *ngIf="this.userCreationId" [disabled]="!userCreationForm.valid ? true : null">Save</button>
                <button class="btn btn-primary" (click)="backToOnboarding()">Cancel</button>
              </div>

              <!-- Can remove commented code after Suraj's Confirmation -->
              <!-- <div class="d-flex gap-2 justify-content-end mt-3" *ngIf="this.license">
                <button class="btn btn-outline-primary" (click)="updateUserCreationforLicense()">Save</button>
                <button class="btn btn-primary" (click)="backToOnboarding()">Cancel</button>
              </div> -->
            </form>
          </div>
        </div>
      </section>
    </section>
  </article>
</main>
